export const sourceOfWealthProofConstants = {
  SOURCE_OF_WEALTH_PROOF_CREATE_LOADING: 'SOURCE_OF_WEALTH_PROOF_CREATE_LOADING',
  SOURCE_OF_WEALTH_PROOF_CREATE_SUCCESS: 'SOURCE_OF_WEALTH_PROOF_CREATE_SUCCESS',
  SOURCE_OF_WEALTH_PROOF_CREATE_FAILURE: 'SOURCE_OF_WEALTH_PROOF_CREATE_FAILURE',
  SOURCE_OF_WEALTH_PROOF_ERROR_RELOAD: 'SOURCE_OF_WEALTH_PROOF_ERROR_RELOAD',

  SOURCE_OF_WEALTH_PROOF_LIST_LOADING: 'SOURCE_OF_WEALTH_PROOF_LIST_LOADING',
  SOURCE_OF_WEALTH_PROOF_LIST_SUCCESS: 'SOURCE_OF_WEALTH_PROOF_LIST_SUCCESS',
  SOURCE_OF_WEALTH_PROOF_LIST_FAILURE: 'SOURCE_OF_WEALTH_PROOF_LIST_FAILURE',

  SOURCE_OF_WEALTH_PROOF_EDIT_LOADING: 'SOURCE_OF_WEALTH_PROOF_EDIT_LOADING',
  SOURCE_OF_WEALTH_PROOF_EDIT_SUCCESS: 'SOURCE_OF_WEALTH_PROOF_EDIT_SUCCESS',
  SOURCE_OF_WEALTH_PROOF_EDIT_FAILURE: 'SOURCE_OF_WEALTH_PROOF_EDIT_FAILURE',

  SOURCE_OF_WEALTH_PROOF_DELETE_LOADING: 'SOURCE_OF_WEALTH_PROOF_DELETE_LOADING',
  SOURCE_OF_WEALTH_PROOF_DELETE_SUCCESS: 'SOURCE_OF_WEALTH_PROOF_DELETE_SUCCESS',
  SOURCE_OF_WEALTH_PROOF_DELETE_FAILURE: 'SOURCE_OF_WEALTH_PROOF_DELETE_FAILURE'
};
